// extracted by css-extract-rspack-plugin
module.exports =  {"storyCardPopup":"X1zlo","whiteTheme":"kpwaz","popupClose":"E12ES","popupScrollArea":"FLnH9","popupMedia":"bUYva","popupImg":"K8a_8","popupTitle":"F5bvP","popupSyn":"DZTla"};